import Vue from 'vue'
import Router from 'vue-router'
import content from '@/components/content'
import login from '@/components/login'

import homes from '@/components/homes'

import template from '@/components/template'
import task from '@/components/task'
import week from '@/components/week'
import store from '@/components/store'
import push from '@/components/push'
import rights from '@/components/rights'
import rightsApp from '@/components/rightsApp'
Vue.use(Router);
export default new Router({
	routes: [
		{
			path: '/',
			redirect:'/login',
		},
		{
			path: '/login',
			name: '/login',
			component: login
		},{
			path: '/content',
			name: '首 页',
			component: content,
			children:[
				{
					path: '/content',
					redirect:'/home',
				},{
					path: '/home',
					name: '首页',
					component: homes.home,
				},{
					path: '/projectList',
					name: '项目列表',
					component: task.projectList,
					children:[
						{
							path: '/projectList/addProject',
							name: '新建项目',
							component: task.addProject,
						},{
							path: '/projectList/projectTable',
							name: '报表列表',
							component: task.projectTable,
						},{
							path: '/projectList/taskList',
							name: '任务管理',
							component: task.taskList,
							children:[
								{
									path: '/projectList/taskList/taskChildList',
									name: '任务列表',
									component: task.taskChildList,
								},{
									path: '/projectList/taskList/tabelList',
									name: '报表列表',
									component: task.tabelList
								},{
									path: '/projectList/taskList/addTask',
									name: '发布任务',
									component: task.addTask
								},{
									path: '/projectList/taskList/addToTask',
									name: '添加任务',
									component: task.addToTask
								}
							],
						}
					]
				},{
					path: '/weekList',
					name: '周计划',
					component: week.weekList,
				},{
					path: '/weekReportList',
					name: '周计划报表',
					component: week.weekReportList,
					children:[
						{
							path: '/weekReportList/weekReportChild',
							name: '查看报表',
							component: week.weekReportChild,
						}
					]
				},{
					path: '/templateList',
					name: '模板管理',
					component: template.templateList,
					children:[
						{
							path: '/templateList/modifyTemplate',
							name: '修改模板',
							component: template.modifyTemplate
						},{
							path: '/templateList/splitList',
							name: '子模版列表',
							component: template.splitList,
							children:[
								{
									path: '/templateList/splitList/splitTemplate',
									name: '新建子模板',
									component: template.splitTemplate
								},{
									path: '/templateList/splitList/modifySplit',
									name: '修改子模板',
									component: template.modifySplit
								},{
									path: '/templateList/splitList/ruleSplitList',
									name: '规则列表',
									component: template.ruleSplitList,
									children:[
										{
											path: '/templateList/splitList/ruleSplitList/addSplitRule',
											name: '新建子模板',
											component: template.addSplitRule
										}
									]
								}
							]
						},{
							path: '/templateList/addTemplate',
							name: '新建模板',
							component: template.addTemplate
						},{
							path: '/templateList/ruleList',
							name: '规则列表',
							component: template.ruleList,
							children:[
								{
									path: '/templateList/ruleList/addRule',
									name: '新增规则',
									component: template.addRule,
								}
							]
						}
					],
				},{
					path: '/store',
					name: '门店管理',
					component: store.infoStore,
					children:[
						{
							path: '/store/seeStore',
							name:'门店详情',
							component: store.seeStore,
						},{
							path: '/store/modifyStore',
							name: '设置门店',
							component: store.modifyStore
						},{
							path: '/store/pushStore',
							name: '导入门店',
							component: store.addStore
						}
					],
				},{
					path: '/pushNews',
					name: '消息推送',
					component: push.pushNews,
					children:[
						{
							path: '/pushNews/addNews',
							name: '发布消息推送',
							component: push.addNews
						},{
							path: '/pushNews/seeNews',
							name: '查看消息推送',
							component: push.seeNews
						},
					],
				},{
					path: '/Right',
					name: '用户管理',
					component: rights.Right,
					children:[
						{	
							path:'/Right/addRight',
							name:'创建用户',
							component: rights.addRight,
						},{	
							path:'/Right/seeRight',
							name:'查看用户详情',
							component: rights.seeRight,
						},{	
							path:'/Right/modifyRight',
							name:'修改用户信息',
							component: rights.modifyRight,
						},{	
							path:'/Right/passRight',
							name:'修改密码',
							component: rights.passRight,
						}
					]
				},{
					path: '/rightsApp',
					name: 'app用户管理',
					component: rightsApp.Right,
					children:[
						{	
							path:'/rightsApp/addRight',
							name:'创建用户',
							component: rightsApp.addRight,
						},{	
							path:'/rightsApp/seeRight',
							name:'查看用户详情',
							component: rightsApp.seeRight,
						},{	
							path:'/rightsApp/modifyRight',
							name:'修改用户信息',
							component: rightsApp.modifyRight,
						},{	
							path:'/rightsApp/passRight',
							name:'修改密码',
							component: rightsApp.passRight,
						}
					]
				}
			]
		}
	]
})





// WEBPACK FOOTER //
// ./src/router/index.js